// extracted by css-extract-rspack-plugin
export default {"container":"zzD_txPUSs46KsMO"};